import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import Navbar from '../components/site/Navbar';
import Footer from '../components/site/Footer';
import { BLOG_POSTS } from '../data/blog';
import { useSeo } from '../lib/seo';

export default function BlogIndex() {
  useSeo({
    title: 'Auto Glass Insights & Guides | A+ Auto Glass Ottawa',
    description:
      'Expert guides on windshield replacement, rock chip repair, ADAS calibration and Ontario auto glass insurance. Written by A+ Auto Glass technicians in Ottawa.',
    path: '/blog',
  });

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#111827]" data-testid="blog-index-page">
      <Navbar />

      <section className="bg-[#0a1220] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14 md:py-20">
          <div className="text-[11px] font-bold tracking-[0.28em] text-[#7fb0ff]">
            <Link to="/" className="hover:text-white transition-colors">
              HOME
            </Link>
            <span className="mx-2 text-white/50">/</span>
            <span className="text-white">INSIGHTS</span>
          </div>
          <h1 className="mt-4 font-black leading-[0.95] tracking-[-0.01em] text-[40px] md:text-[56px] lg:text-[64px]">
            Insights &amp; Guides.
          </h1>
          <p className="mt-5 text-[16px] md:text-[18px] text-white/80 max-w-2xl leading-[1.6] font-light">
            Practical guides for Ontario drivers on windshield damage, ADAS safety systems, and how to use your
            insurance for glass repair.
          </p>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {BLOG_POSTS.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                data-testid={`blog-index-post-${p.slug}`}
                className="group h-full flex flex-col bg-white rounded-2xl border border-slate-100 shadow-[0_2px_16px_rgba(15,23,42,0.05)] hover:shadow-[0_18px_40px_rgba(13,91,215,0.1)] hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                <div className="aspect-[16/9] overflow-hidden bg-slate-100">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-7 md:p-8 flex-1 flex flex-col">
                  <div className="flex items-center gap-3 text-[11px] font-bold tracking-[0.2em] text-[#0D5BD7]">
                    <span>{p.category.toUpperCase()}</span>
                    <span className="w-1 h-1 rounded-full bg-slate-300" />
                    <span className="inline-flex items-center gap-1 text-slate-500">
                      <Calendar className="w-3 h-3" /> {p.date}
                    </span>
                    <span className="w-1 h-1 rounded-full bg-slate-300" />
                    <span className="inline-flex items-center gap-1 text-slate-500">
                      <Clock className="w-3 h-3" /> {p.readTime}
                    </span>
                  </div>
                  <h2 className="mt-4 text-[20px] md:text-[22px] font-black text-[#111827] tracking-tight leading-[1.2] group-hover:text-[#0D5BD7] transition-colors">
                    {p.title}
                  </h2>
                  <p className="mt-3 text-[14.5px] text-[#5F6773] leading-[1.7] flex-1">{p.excerpt}</p>
                  <div className="mt-5 inline-flex items-center text-[11px] font-bold tracking-[0.22em] text-[#0D5BD7]">
                    READ ARTICLE
                    <ArrowRight className="w-3.5 h-3.5 ml-2 transition-transform group-hover:translate-x-1" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
